// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[modules-two-columns][data-v-f7b5b14e] [modules]>section{justify-content:flex-start;row-gap:1rem}[modules-two-columns][data-v-f7b5b14e] [modules]>section>*{padding:0!important}[modules-two-columns][data-v-f7b5b14e] [modules]>section>[modules-text]:first-child{padding-top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
